import { sendGAEvent } from '../utils';

export enum ProfileVerificationEvents {
  PROFILE_VERIFICATION_ERROR = 'profile_verification_error',
}

/**
 * @param data - The data to be sent with the event.
 * @description This function sends a Google Analytics event when profile verification fails.
 * It uses the `sendGAEvent` utility to send the event with the specified event name and category.
 * The event name is `profile_verification_error` and the category is `profileVerification`.
 */

export const sendProfileVerificationFailed = (error?: string) => {
  sendGAEvent(ProfileVerificationEvents.PROFILE_VERIFICATION_ERROR, {
    event_category: 'profileVerification',
    error,
  });
};
